import { storiesApi } from '../api/stories';
import { plottrackPath } from './plottrackPath';

/**
 * Land in that book's Discovery talk — same room as Open this book
 * and the book-name list. Start this book reuses this after persist.
 */
export async function openStartedBook(story, navigate, setProjectAndStory, project) {
  let next = story;
  let sessionId = story?.discovery_session_id;
  if (story?.id && !sessionId) {
    const ensured = await storiesApi.ensureDiscoverySession(story.id);
    sessionId = ensured?.session_id || ensured?.id;
    next = { ...story, discovery_session_id: sessionId };
  }
  if (project && next) setProjectAndStory(project, next);
  if (sessionId) {
    navigate(`/chat/${sessionId}`);
    return;
  }
  navigate(plottrackPath(story?.id));
}
